
import { useAlerts } from 'react-native-paper-alerts';
import { AlertButton, AlertsOptions } from 'react-native-paper-alerts/lib/typescript/type';
import * as theme from '@lib/theme';

export type AppAlertType = (title: string, message?: string, button?: AlertButton[], options?: AlertsOptions) => void;

export const useAppAlerts = () => {

    const alerts = useAlerts();

    const styledAlert = (title: string, content?: string, button?: AlertButton[], options?: AlertsOptions) => {

        return alerts.alert(title, content, button,
            {
                minWidth: Math.min(500, theme.contentWidth),
                ...options,
            }
        );
    };

    return { alert: styledAlert };
};



// import { useAppAlerts } from '@components/2-molecules/Alert';

// const alerts = useAppAlerts();

// alerts.alert(
//   'Login',
//   'A new version is ready for download.',
//   [
//     { text: 'OK', onPress: () => {} },
//   ]
// );